import env from "Consts/env";
import { handle498OnClient } from "Helpers/is498";
import { apiSlice } from "../api/apiSlice";

export const productApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getProductList: builder.query({
			query: (args) => {

				const { isDirect } = args.params;

				const isDirectBoolean = !!isDirect;

				// Construct URLs
				const baseURL = isDirectBoolean
					? `${process.env.NEXT_PUBLIC_MAGENTO_BS}/magento/product`
					: "/api/fds-product";

				const url = baseURL;

				return {
					url,
					headers: {
						...env.HEADERS,
					},
					params: {
						...args.params,
					},
					validateStatus: (response) => response.status === 304
						|| (response.status >= 200 && response.status < 300)
					,
				};

			},
			providesTags: ["ProductsList"],
		}),
		getQuickReviewProduct: builder.query({
			query: (args) => ({
				url: `/api/fds-product/${args.params}`,
				headers: {
					...env.HEADERS,
				},
				validateStatus: (response) => response.status === 304
					|| (response.status >= 200 && response.status < 300)
				,
			}),
			// providesTags: ["ProductsList"],
		}),
		getSemilarProduct: builder.query({
			query: (args) => ({
				url: `/api/fds-product/${args?.params?.id}/similar`,
				headers: {
					...env.HEADERS,
				},
				validateStatus: (response) => response.status === 304
					|| (response.status >= 200 && response.status < 300)
				,
			}),
		}),
		getProductWishlist: builder.query({
			query: (args) => ({
				url: `/api/fds-user/product/${args?.params?.userid}`,
				headers: {
					...env.HEADERS,
					userid: args?.params?.userid,
					productid: args?.params?.productId,
				},
				validateStatus: (response) => response.status === 304
					|| (response.status >= 200 && response.status < 300)
				,
			}),
			providesTags: ["WishListProduct"],
		}),
		postSetWishlist: builder.mutation({
			query: (body) => {

				const { userid, ...payload } = body;
				return {
					url: `/api/fds-user/product/${userid}`,
					method: "POST",
					headers: {
						...env.HEADERS,
					},
					body: payload,
				};

			},
			async onQueryStarted(id, { dispatch, queryFulfilled }) {

				try {

					await queryFulfilled;

				} catch (err) {

					dispatch(handle498OnClient(err?.error?.data));

				}

			},
			invalidatesTags: ["WishListProduct"],
		}),
		getPriceAndStock: builder.query({
			query: (args) => ({
				url: `/api/fds-product/${args?.params?.productSku}/price-and-stock`,
				headers: {
					...env.HEADERS,
				},
				validateStatus: (response) => response.status === 304
					|| (response.status >= 200 && response.status < 300)
				,
			}),
		}),
		getFlashSale: builder.query({
			query: (args) => ({
				url: `/api/fds-product/${args?.params?.productId}/variants/flashsale`,
				headers: {
					...env.HEADERS,
				},
				validateStatus: (response) => response.status === 304
					|| (response.status >= 200 && response.status < 300),
				providesTags: ["Flashsale"],
			}),
		}),
		getListUserWishlist: builder.query({
			query: (args) => ({
				url: `/api/fds-user/product/${args?.params?.userid}/wishlist`,
				headers: {
					...env.HEADERS,
					userid: args?.params.userid,
					authorization: args?.params.authorization,
				},
				validateStatus: (response) => response.status === 304
					|| (response.status >= 200 && response.status < 300)
				,
			}),
			providesTags: ["UserWishlistProduct"],
		}),
		getListFlashSale: builder.query({
			query: (args) => ({
				url: "/api/fds-flash-sale",
				headers: {
					...env.HEADERS,
				},
				params: {
					...args.params,
				},
				validateStatus: (response) => response.status === 304
					|| (response.status >= 200 && response.status < 300),
			}),
			transformResponse: (response) => {

				const res = response.data[0];
				return res;

			},
			providesTags: ["ListFlashsale"],
		}),
		getProductRecomendation: builder.query({
			query: (params) => ({
				url: `/api/fds-product/${params?.productId}/recommendation`,
				headers: {
					...env.HEADERS,
				},
				validateStatus: (response) => response.status === 304
					|| (response.status >= 200 && response.status < 300)
				,
			}),
			transformResponse: (response) => {

				// Periksa apakah ada kode status 498
				if (response?.meta?.code && response.meta.code === 498) {

					handle498OnClient(response); // Jalankan handler
					return null; // Atau data default jika login diperlukan

				}

				// Jika bukan 498, teruskan respons normal
				return response;

			},
		}),
	}),
});

export const {
	useGetProductListQuery,
	useGetQuickReviewProductQuery,
	useGetSemilarProductQuery,
	useGetProductWishlistQuery,
	usePostSetWishlistMutation,
	useGetPriceAndStockQuery,
	useGetFlashSaleQuery,
	useGetListUserWishlistQuery,
	useGetListFlashSaleQuery,
	useLazyGetListFlashSaleQuery,
	useGetProductRecomendationQuery,
} = productApiSlice;
